import React, {
  FC,
  FormEvent,
  FormEventHandler,
  useEffect,
  useState,
} from "react"
import style from "./styles.module.css"
import InputPassword from "../../common/ui-kit/inputs/input_password"
import GradientBtn from "../../components/GradientBtn"
import { useFormik } from "formik"
import Code from "./code"
import useRegistrationFetch from "./useRegistrationFetch"
import { useAppDispatch } from "../../app/hooks"
import { hide } from "../../pages/signIn/SignInSlice"
import { isCheckUsername } from "../../app/common/validationFetch"
import {
  validEmailForRegistration,
  validLoginForRegistration,
} from "../../app/common/validations"
import { validateForm } from "./FormValidation"
import { ConsentCheckbox } from "@pages/signIn/components/ConsentCheckbox";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { ExtrnalLins } from "@utils/ExtrnalLins";

export interface RegisterFormValues {
  userName: string
  email: string
  password: string
  rePassword: string
}

const RegistrationForm: FC<RegisterFormValues> = () => {
  const [isSuccess, setIsSuccess] = useState(false)
  const [isAgreePrivacy, setIsAgreePrivacy] = useState<boolean>(false)
  const [isAgreePrivacyProcess, setIsAgreePrivacyProcess] = useState<boolean>(false)

  const { tryRegistration, registrantId, isError } = useRegistrationFetch()
  const handlePrivcyCheck = (event: React.ChangeEvent<HTMLInputElement>)=>{
    setIsAgreePrivacy(
      event.target.checked
    )
  }
  const handlePrivcyCheckProcess = (event: React.ChangeEvent<HTMLInputElement>)=>{
    setIsAgreePrivacyProcess(
      event.target.checked
    )
  }
  const agrement: boolean = isAgreePrivacy && isAgreePrivacyProcess
  const dispatch = useAppDispatch()
  const formik = useFormik<RegisterFormValues>({
    initialValues: {
      userName: "",
      email: "",
      password: "",
      rePassword: "",
    },
    validate: validateForm,
    onSubmit: (values) => {
      tryRegistration(values)
      setIsSuccess(true)
    },
  })
  const handleCodeFetch = () => {
    dispatch(hide())
  }
  if (isSuccess && registrantId) {
    return (
      <Code
        email={formik.values.email}
        handleSubmit={handleCodeFetch}
        registrantId={registrantId}
      />
    )
  }

  const isFormValid =
    formik.values.userName &&
    formik.values.email &&
    formik.values.password &&
    formik.values.rePassword &&
    formik.values.password === formik.values.rePassword && agrement

  return (
    <form className={style.form_box}>
      <div className={style.input_container}>
        <InputPassword
          errorText={
            formik.touched.userName && formik.errors.userName
              ? formik.errors.userName
              : null
          }
          name={"userName"}
          value={formik.values.userName}
          onBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          type={"text"}
          placeholder={"@username"}
          autocomplete={"off"}
        />
        <InputPassword
          errorText={
            formik.touched.email && formik.errors.email
              ? formik.errors.email
              : null
          }
          name={"email"}
          value={formik.values.email}
          onBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          type={"text"}
          placeholder={"email"}
        />
        <InputPassword
          errorText={
            formik.touched.password && formik.errors.password
              ? formik.errors.password
              : null
          }
          name={"password"}
          value={formik.values.password}
          onBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          type={"password"}
          placeholder={"password"}
        />
        <InputPassword
          errorText={
            formik.touched.password && formik.errors.rePassword
              ? formik.errors.rePassword
              : null
          }
          name={"rePassword"}
          value={formik.values.rePassword}
          onBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          type={"password"}
          placeholder={"password"}
        />
      </div>
      {isError ? <p className={style.error_text}>Ошибка сервера</p> : null}
      <ConsentCheckbox onChange={handlePrivcyCheck} checked={isAgreePrivacy} renderContent={
        <Typography variant="body2" style={{cursor: "default"}}>
          я согласен с обработкой{' '}
          <Link target="_blank" rel="noopener noreferrer" to="/documents/consent-to-personal-data-processing" className={style.policy_link} title= "Согласие на обработку персональных данных">
            персональных данных
          </Link>
        </Typography>
      } />
      <ConsentCheckbox onChange={handlePrivcyCheckProcess} checked={isAgreePrivacyProcess} renderContent={
        <Typography variant="body2" style={{cursor: "default"}}>
          я согласен {' '}
          <Link target="_blank" rel="noopener noreferrer" to="/documents/personal-data-processing-policy" className={style.policy_link} title="Положение об обработке персональных данных">
            с условиями обработки 
          </Link> {' '} персональных данных
        </Typography>
      } />
      <GradientBtn
        type="submit"
        disabled={!isFormValid}
        title="Регистрация"
        aria-label="signup"
        btnStyle={{
          width: "fit-content",
          minWidth: "128px",
          padding: "12px 16px",
          margin: "16px 0",
          ...(!isFormValid && {
            background: "var(--btns-disabled-bg)",
            color: "var(--btns-disabled-text)",
            pointerEvents: "none",
          }),
        }}
        handleAction={formik.handleSubmit}
      />
    </form>
  )
}
export default RegistrationForm
